var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{ref:"textarea",staticClass:"w-full form-input form-input-bordered py-2",attrs:{"rows":"2","placeholder":_vm.placeholder,"readonly":_vm.readonly},domProps:{"value":_vm.value},on:{"change":function($event){return _vm.$emit('input', $event.target.value)},"keyup":function($event){return _vm.$emit('input', $event.target.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }